import React from "react"
import { Row, Col, Button, Space } from "antd"
import styled from "styled-components"

import Logo from "../../images/logoWorkClass.png"
import Sticky from "react-stickynode"

const StyledMenu = styled.div`
    padding: 10px 50px 5px;
    border: none !important;
    background: #f7f8ff;

    @media (max-width: 768px) {
        padding: 10px 15px;
    }
`
const StyledLogo = styled.img`
    height: 40px;

    @media (max-width: 768px) {
        height: 30px;
    }
`
const StyledButton: typeof Button = styled(Button)`
    font-weight: bold;
    padding: 0.1px 20px !important;
`

const Navbar: React.FC = () => {
    return (
        <Sticky top={0} innerZ={999}>
            <StyledMenu mode="horizontal">
                <Row>
                    <Col span={24} md={{ push: 3, span: 18 }}>
                        <Row justify="space-between">
                            <div>
                                <StyledLogo
                                    src={Logo}
                                    alt={"Work CLass Logo"}
                                />
                            </div>
                            <Space size="middle">
                                <a href="/login">
                                    <strong>Sign In</strong>
                                </a>
                                <StyledButton
                                    href="/login"
                                    type="primary"
                                    shape="round"
                                    size="large"
                                >
                                    Try for free
                                </StyledButton>
                            </Space>
                        </Row>
                    </Col>
                </Row>
            </StyledMenu>
        </Sticky>
    )
}

export default Navbar
